module.exports = __webpack_public_path__ + "img/album15_13.c9281665.jpg";